import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OrderProductTaxJoinService } from '../order-product-tax-join.service';
import { OrderProductTaxJoin } from '../order-product-tax-join';
import { OrderProductTaxJoinComponent } from '../order-product-tax-join/order-product-tax-join.component';

@Component({
    selector: 'app-order-product-tax-join-list',
    templateUrl: './order-product-tax-join-list.component.html',
    styleUrls: ['./order-product-tax-join-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OrderProductTaxJoinListComponent implements OnInit {
	constructor(
		private orderProductTaxJoinService: OrderProductTaxJoinService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = orderProductTaxJoinService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() orderProductId: any;
	orderProductTaxJoins: any;
	orderProductTaxJoin: OrderProductTaxJoin;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'OrderProductVO.name', header: 'order Product Name', width: 'auto' },
		{ field: 'OrderTaxVO.name', header: 'order Tax Name', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.orderProductTaxJoinId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-orderProductTaxJoin-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.orderProductId)
			{
				// show only activities that are assigned to this activityId
				let orderProductIdFilter = { 'orderProductId': { 'value': this.orderProductId, 'matchMode': 'in' } };
				Object.assign(event.filters, orderProductIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.orderProductTaxJoinService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.orderProductTaxJoins = res.data.orderProductTaxJoins;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.orderProductTaxJoins = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(orderProductTaxJoin: OrderProductTaxJoin) {
		try {
			this.formLoading = true;
			this.orderProductTaxJoinService.update(orderProductTaxJoin)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.orderProductTaxJoins.map((orderProductTaxJoin, i) => {
							if (orderProductTaxJoin.orderProductTaxJoinId === res.data.orderProductTaxJoin.orderProductTaxJoinId) {
								this.orderProductTaxJoins[i] = res.data.orderProductTaxJoin;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(orderProductTaxJoin: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(orderProductTaxJoin));

			this.formLoading = true;
			this.orderProductTaxJoinService.delete(orderProductTaxJoin.orderProductTaxJoinId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.orderProductTaxJoins.splice(this.orderProductTaxJoins.indexOf(orderProductTaxJoin), 1);
						this.recordTotal = this.orderProductTaxJoins.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OrderProductTaxJoin ' + orderProductTaxJoin.orderProductTaxJoinId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OrderProductTaxJoin ' + orderProductTaxJoin.orderProductTaxJoinId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "50vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Order Product Tax Join',
			orderProductId: this.orderProductId,
			orderProductTaxFlag: false
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderProductTaxJoinComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.addOrderProductTaxJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				// dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(orderProductTaxJoin: OrderProductTaxJoin) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "50vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			orderProductTaxJoin: orderProductTaxJoin,
			orderProductId: this.orderProductId,
			orderProductTaxFlag: true,
			title: 'Edit Order Product Tax Join'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderProductTaxJoinComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.updateOrderProductTaxJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				// dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.deleteOrderProductTaxJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOrderProductTaxJoinCB(orderProductTaxJoin: OrderProductTaxJoin) {
		console.log('Adding OrderProductTaxJoin: ' + JSON.stringify(orderProductTaxJoin));
		// if we don't have a orderProductTaxJoins array yet...
		if (!this.orderProductTaxJoins) {
			this.orderProductTaxJoins = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.orderProductTaxJoins.unshift(orderProductTaxJoin);

		// no idea what this is but it is required to update the array
		this.orderProductTaxJoins = [...this.orderProductTaxJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderProductTaxJoin ' + orderProductTaxJoin.orderProductTaxJoinId + ' Added', life: 3000 });
	}

	updateOrderProductTaxJoinCB(orderProductTaxJoin: OrderProductTaxJoin) {
		console.log('Updating OrderProductTaxJoin: ' + JSON.stringify(orderProductTaxJoin));
		let itemIndex = this.orderProductTaxJoins.findIndex((item: any) => item.orderProductTaxJoinId === orderProductTaxJoin.orderProductTaxJoinId);
		this.orderProductTaxJoins[itemIndex] = orderProductTaxJoin;

		// no idea what this is but it is required to update the array
		this.orderProductTaxJoins = [...this.orderProductTaxJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderProductTaxJoin ' + orderProductTaxJoin.orderProductTaxJoinId + ' Updated', life: 3000 });
	}

	deleteOrderProductTaxJoinCB(orderProductTaxJoin: OrderProductTaxJoin) {
		console.log('Removing OrderProductTaxJoin: ' + orderProductTaxJoin);
		this.orderProductTaxJoins.splice(this.orderProductTaxJoins.indexOf(orderProductTaxJoin), 1);
		this.recordTotal = this.orderProductTaxJoins.length;

		// no idea what this is but it is required to update the array
		this.orderProductTaxJoins = [...this.orderProductTaxJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderProductTaxJoin ' + orderProductTaxJoin.orderProductTaxJoinId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.orderProductTaxJoins ? this.first === (this.orderProductTaxJoins.length - this.rows) : true; }
	isFirstPage(): boolean { return this.orderProductTaxJoins ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(orderProductTaxJoin: any) {
		if (orderProductTaxJoin?.status) {
			const status = this.statuses.find((e: any) => e.value == orderProductTaxJoin.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
